/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /* ------------------------------------------------------------------------
   * Shop Pay Installments banner - recolour the Shop Pay lockup.
   *
   * {{ form | payment_terms }} in snippets/product-price.liquid renders
   * Shopify's <shopify-payment-terms> web component. Its markup AND its
   * stylesheet live inside a shadow root (the "constructed stylesheet" rules
   * you see in DevTools), so nothing in theme.css can select the purple logo
   * no matter how specific the selector or how many !importants it carries.
   *
   * Preferred path: append a <style> to the element's shadowRoot. The lockup
   * paths are painted with currentColor, so setting `color` on the purple
   * class recolours the pill while leaving the white "shop" wordmark alone.
   *
   * Fallback: if the shadow root is closed (shadowRoot stays null), put a
   * `filter` on the host element instead - filter applies to an element's
   * entire rendered subtree, so it crosses the shadow boundary. grayscale(1)
   * turns the purple into charcoal and leaves the already-neutral banner
   * text effectively untouched.
   * --------------------------------------------------------------------- */

  var SHOP_PAY_LOGO_COLOR = '#b7aa93'; // btn_primary_bg from settings_data.json
  var SHOP_PAY_FALLBACK_FILTER = 'grayscale(1)';
  var SHOP_PAY_CSS =
    '[class*="text-purple"],[class*="purple-primary"]' +
    '{color:' + SHOP_PAY_LOGO_COLOR + ' !important}';

  var shopPayTimer = null;
  var shopPayAttempts = 0;
  var shopPayRaf = 0;

  function paintShopPay() {
    var nodes = document.querySelectorAll('shopify-payment-terms');
    var unresolved = 0;

    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var root = el.shadowRoot;

      // Either the custom element has not upgraded yet, or the root is closed.
      // Poll a while before deciding it is the latter.
      if (!root) {
        unresolved++;
        continue;
      }

      // A previously applied fallback would grey out the new colour.
      if (el.style.filter === SHOP_PAY_FALLBACK_FILTER) el.style.filter = '';

      if (root.querySelector('style[data-shop-pay-recolor]')) continue;

      var style = document.createElement('style');
      style.setAttribute('data-shop-pay-recolor', '');
      style.textContent = SHOP_PAY_CSS;
      root.appendChild(style);
    }

    return unresolved;
  }

  function applyShopPayFallback() {
    var nodes = document.querySelectorAll('shopify-payment-terms');
    for (var i = 0; i < nodes.length; i++) {
      if (!nodes[i].shadowRoot) nodes[i].style.filter = SHOP_PAY_FALLBACK_FILTER;
    }
  }

  function shopPayTick() {
    shopPayTimer = null;

    if (paintShopPay() === 0) return; // everything reachable is painted
    if (shopPayAttempts++ < 40) {     // keep trying for ~10s
      shopPayTimer = setTimeout(shopPayTick, 250);
      return;
    }
    applyShopPayFallback();
  }

  function scheduleShopPay() {
    if (shopPayTimer) return;
    shopPayAttempts = 0;
    shopPayTimer = setTimeout(shopPayTick, 0);
  }

  // The banner is re-rendered when the variant changes, and on quick-view /
  // section-render loads, so watch for it coming back rather than running once.
  if (window.MutationObserver) {
    new MutationObserver(function() {
      if (shopPayRaf) return;
      shopPayRaf = requestAnimationFrame(function() {
        shopPayRaf = 0;
        scheduleShopPay();
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  scheduleShopPay();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
